<script>
import { Line } from 'vue-chartjs'
import { mapState } from 'vuex'
import zoom from 'chartjs-plugin-zoom'
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  extends: Line,
  props: ['dataObject', 'graphValue', 'zoomChanger'],
  data() {
    return {
      tickNumber: 0,
      chartData: {
        labels: [],
        datasets: [],
        actualTickNumber: 0
      },
      options: {
        ticks: {
          sampleSize: 0.1
        },
        animation: {
          duration: 0
        },
        hover: {
          animationDuration: 0
        },
        responsiveAnimationDuration: 0,
        elements: {
          point: {
            radius: 0.1,
            borderWidth: 1
          },
          line: {
            tension: 0
          }
        },
        plugins: {
          zoom: {
            zoom: {
              enabled: true,
              mode: 'x',
              speed: 0.2,
              onZoom: function(graph) {
                graph.chart.data.actualTickNumber =
                  graph.chart.scales['x-axis-0'].ticks.length
                graph.chart.scales['x-axis-0'].options.time.unit = null
              }
            }
          }
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Brzina (km/h)',
                fontSize: 14,
                padding: 10
              },
              ticks: {
                autoSkip: true,
                suggestedMax: 100,
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              type: 'time',
              autoSkip: true,
              time: {
                minUnit: 'second',
                parser: 'DD.MM.YYYY. HH:mm:ss',
                stepSize: 6,
                displayFormats: {
                  hour: 'MMM D - hA',
                  minute: 'MMM D - h:mm a'
                }
              },
              gridLines: {
                display: true
              }
            }
          ]
        },
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          caretPadding: 15,
          callbacks: {
            afterBody: function(item) {
              var reportData = JSON.parse(localStorage.getItem('reportData'))
              let actualItem = reportData[item[0].index]
              let keys = Object.keys(actualItem)
              let multistringText = []
              keys.forEach(key => {
                if (actualItem[key] != null && key != 'timestamp') {
                  multistringText.push(key + ': ' + actualItem[key])
                }
              })
              return multistringText
            }
          }
        }
      }
    }
  },
  methods: {
    setUpDefaultYAxes() {
      this.options.scales.yAxes = [
        {
          scaleLabel: {
            display: true,
            labelString: 'Brzina (km/h)',
            fontSize: 14,
            padding: 10
          },
          ticks: {
            autoSkip: true,
            suggestedMax: 10,
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        }
      ]
    },
    setYAxesForCombinedGraph() {
      this.options.scales.yAxes = [
        {
          id: 'left-y-axis-speed',
          type: 'linear',
          scaleLabel: {
            display: true,
            labelString: translate('Speed', 'graphs'),
            fontColor: '#388E3C',
            fontSize: 14,
            padding: 10
          },
          position: 'left',
          ticks: {
            autoSkip: true,
            suggestedMax: 100,
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        },
        {
          id: 'left-y-axis-fuel',
          type: 'linear',
          scaleLabel: {
            display: true,
            labelString: translate('Fuel percentage', 'graphs'),
            fontColor: 'blue',
            fontSize: 14,
            padding: 10
          },
          position: 'left',
          ticks: {
            autoSkip: true,
            suggestedMax: 100,
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        },
        {
          id: 'right-y-axis',
          type: 'linear',
          scaleLabel: {
            display: true,
            labelString: translate('Mileage', 'graphs'),
            fontSize: 14,
            fontColor: 'red',
            padding: 10
          },
          position: 'right',
          ticks: {
            autoSkip: true,
            suggestedMax: 100,
            beginAtZero: true
          },
          gridLines: {
            display: true
          }
        }
      ]
    },
    setUpCombinedGraph() {
      let dataToReturn = []
      let speedData = {}
      let fuelPercentageData = {}
      let mileageData = {}
      for (let data of this.dataObject) {
        let any = false
        if (speedData.vehicleLabel == data.vehicleLabel) {
          speedData.data.push(data['speed'])
          any = true
        }
        if (fuelPercentageData.vehicleLabel == data.vehicleLabel) {
          fuelPercentageData.data.push(data['fuelLevelPercentage'])
          any = true
        }
        if (mileageData.vehicleLabel == data.vehicleLabel) {
          mileageData.data.push(data['mileage'])
          any = true
        }
        if (any == false) {
          speedData = {
            vehicleLabel: data.vehicleLabel,
            timestamp: data.timestamp,
            label: translate('Speed', 'graphs'),
            driverName: data.driverName,
            data: [data['speed']],
            fill: false,
            borderColor: '#388E3C',
            borderWidth: 2,
            yAxisID: 'left-y-axis-speed'
          }
          fuelPercentageData = {
            vehicleLabel: data.vehicleLabel,
            timestamp: data.timestamp,
            label: translate('Fuel percentage', 'graphs'),
            driverName: data.driverName,
            data: [data['fuelLevelPercentage']],
            fill: false,
            borderColor: 'blue',
            borderWidth: 2,
            yAxisID: 'left-y-axis-fuel'
          }
          mileageData = {
            vehicleLabel: data.vehicleLabel,
            timestamp: data.timestamp,
            label: translate('Mileage', 'graphs'),
            driverName: data.driverName,
            data: [data['mileage']],
            fill: false,
            borderColor: 'red',
            borderWidth: 2,
            yAxisID: 'right-y-axis'
          }
        }
      }
      dataToReturn.push(fuelPercentageData)
      dataToReturn.push(mileageData)
      dataToReturn.push(speedData)
      this.chartData.datasets = dataToReturn
    },
    setUpDataSet() {
      if (this.graphValue != 'combined') {
        this.setUpDefaultYAxes()
        let dataToReturn = []
        for (let data of this.dataObject) {
          let any = false
          for (let singleObject of dataToReturn) {
            if (singleObject.vehicleId == data.vehicleId) {
              singleObject.data.push(data[this.graphValue])
              any = true
            }
          }
          if (any == false) {
            dataToReturn.push({
              vehicleId: data.vehicleId,
              timestamp: data.timestamp,
              label: data.vehicleLabel,
              driverName: data.driverName,
              data: [data[this.graphValue]],
              fill: false,
              borderColor: '#388E3C',
              borderWidth: 2
            })
          }
        }
        this.chartData.datasets = dataToReturn
      } else {
        this.setYAxesForCombinedGraph()
        this.setUpCombinedGraph()
      }
    },
    setUpLabels() {
      let dates = []
      for (let data of this.dataObject) {
        dates.push(data.timestamp)
      }
      this.chartData.labels = dates
    },
    setupStepSize() {
      let beginDate = this.dataObject[0].timestamp
      let endDate = this.dataObject[this.dataObject.length - 1].timestamp
      let splitedBeginDate = new Date(beginDate)
      let splitedEndDate = new Date(endDate)
      let dateDiff = (splitedEndDate - splitedBeginDate) / (1000 * 60 * 60 * 24)
      if (dateDiff <= 0.25) {
        this.options.scales.xAxes[0].time.unit = 'minute'
        this.options.scales.xAxes[0].time.stepSize = 15
      }
      if (dateDiff > 0.25 && dateDiff <= 1) {
        this.options.scales.xAxes[0].time.unit = 'hour'
        this.options.scales.xAxes[0].time.stepSize = 1
      }
      if (dateDiff > 1 && dateDiff < 4) {
        this.options.scales.xAxes[0].time.unit = 'hour'
        this.options.scales.xAxes[0].time.stepSize = 6
      }
      if (dateDiff >= 4 && dateDiff <= 8) {
        this.options.scales.xAxes[0].time.unit = 'hour'
        this.options.scales.xAxes[0].time.stepSize = 8
      }
      if (dateDiff > 8 && dateDiff <= 15) {
        this.options.scales.xAxes[0].time.unit = 'hour'
        this.options.scales.xAxes[0].time.stepSize = 12
      }
      if (dateDiff > 15 && dateDiff <= 30) {
        this.options.scales.xAxes[0].time.unit = 'day'
        this.options.scales.xAxes[0].time.stepSize = 1
      }
      if (dateDiff > 30) {
        this.options.scales.xAxes[0].time.unit = 'day'
        this.options.scales.xAxes[0].time.stepSize = Math.floor(dateDiff / 16)
      }
    },
    resetZoomAction() {
      this.setUpDataSet()
      this.setUpLabels()
      this.setupStepSize()
      this.renderChart(this.chartData, this.options)
    }
  },
  computed: {
    ...mapState('history', ['graphData']),
    isZoomed() {
      return this.chartData.actualTickNumber
    }
  },
  mounted() {
    this.setUpDataSet()
    this.setUpLabels()
    this.setupStepSize()
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    dataObject: {
      handler() {
        this.setUpDataSet()
        this.setUpLabels()
        this.setupStepSize()
        this.renderChart(this.chartData, this.options)
      }
    },
    graphValue: {
      handler() {
        this.setUpDataSet()
        let charDataToUpper =
          this.graphValue[0].toUpperCase() + this.graphValue.slice(1)
        if (this.graphValue != 'combined') {
          this.options.scales.yAxes[0].scaleLabel.labelString = translate(
            charDataToUpper,
            'graphs'
          )
        }
        this.setUpLabels()
        this.renderChart(this.chartData, this.options)
      }
    },
    isZoomed: {
      handler() {
        this.$emit('zoomed', true)
      }
    },
    zoomChanger: {
      handler() {
        this.resetZoomAction()
      }
    }
  }
}
</script>
